const features = [
  {
    icon: "ri-price-tag-3-line",
    title: "安さよりも「質」で選ばれる徹底サポート",
    body: "手数料は無料。一歩踏み出す不安や迷いに寄り添い、渡航前から帰国後まで全力サポート。誰もが主役になれる留学を、一番身近な存在として形にします。",
    img: "https://public.readdy.ai/ai/img_res/bfd8ade22ef2f3601384b499461aa6f8.jpg",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "ヨーロッパに日本人スタッフ常駐",
    body: "ヨーロッパ現地にも日本人スタッフが常駐。時差があっても困ったときはいつでも日本語で相談できる安心のサポート体制です。",
    img: "https://readdy.ai/api/search-image?query=Japanese%20staff%20customer%20support%20Dublin%20office%20multicultural%20team%20bright%20workspace%20welcoming%20environment%20professional%20friendly&width=400&height=280&seq=feature-002&orientation=landscape",
  },
  {
    icon: "ri-shield-check-line",
    title: "高校留学やジュニア層の経験が豊富",
    body: "学生向けのサポート体制に自信あり。治安の良いアイルランドで、現地の生活を熟知したスタッフが、お子様の安全と成長を徹底的にバックアップします。",
    img: "https://readdy.ai/api/search-image?query=modern%20language%20school%20classroom%20Ireland%20Dublin%20students%20studying%20English%20professional%20teacher%20bright%20classroom%20academic%20environment&width=400&height=280&seq=feature-003&orientation=landscape",
  },
];

export default function WhyClassLiveSection() {
  return (
    <section id="why" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="text-emerald-600 text-sm font-semibold tracking-widest uppercase">Why ClassLive留学</span>
          <h2 className="text-3xl font-bold text-gray-800 mt-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            ✅ ClassLive留学のここがいい！ ✅
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {features.map((f, i) => (
            <div key={i} className="rounded-lg overflow-hidden border border-gray-100 hover:border-emerald-200 transition-all group">
              <div className="w-full h-44">
                <img src={f.img} alt={f.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-7 h-7 flex items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
                    <i className={`${f.icon} text-sm`} />
                  </span>
                  <h3 className="font-bold text-gray-800 text-sm">{f.title}</h3>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">{f.body}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-gray-50 rounded-lg p-8 border border-gray-100">
          <p className="text-center text-lg font-bold text-gray-800 mb-5">✨ あなたのサポートをします</p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: "ri-search-line", label: "語学学校選び" },
              { icon: "ri-file-list-3-line", label: "ビザ申請サポート" },
              { icon: "ri-home-4-line", label: "住居・滞在先手配" },
              { icon: "ri-plane-line", label: "航空券アドバイス" },
              { icon: "ri-shield-cross-line", label: "海外保険手配" },
              { icon: "ri-map-pin-line", label: "現地オリエンテーション" },
              { icon: "ri-chat-smile-2-line", label: "帰国後のフォロー" },
              { icon: "ri-graduation-cap-line", label: "進学相談" },
            ].map((s) => (
              <div key={s.label} className="flex items-center gap-2 text-sm text-gray-600">
                <span className="w-5 h-5 flex items-center justify-center text-emerald-500">
                  <i className={`${s.icon} text-sm`} />
                </span>
                {s.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
